import React from "react";
import PropTypes from "prop-types";
import { SecurityIcon } from "../../theme/assets";
import { defineMessages, injectIntl, FormattedDate, FormattedMessage } from "react-intl";
import { pure } from "recompose";
import classnames from "classnames";
import styles from "./CancellationMessage.scss";
import moment from "moment";
export const msgs = defineMessages({
  cancelableUntil: {
    id: "cancellationMessage.text.cancelableUntilDate",
    description: "Notify the date until the element is cancelable",
    defaultMessage: "Can be cancelled online until",
  },
});

export function CancellationMessage({
  cancellationRelease,
  reservationStartDate,
  includeIcon,
  className,
  mode,
  customIcon,
}) {
  if (cancellationRelease === null || cancellationRelease === -1) {
    return null;
  }
  const maxCancellationDate = moment(reservationStartDate)
    .endOf("day")
    .subtract(cancellationRelease, "hours")
    .toDate();
  const today = new Date();
  if (maxCancellationDate <= today) {
    return null;
  }
  if (mode === "SHORT") {
    return (
      <span
        className={classnames(
          "wbkv9-CancellationMessage--short",
          "CancellationMessage",
          className,
          styles.cancelable
        )}>
        <FormattedMessage {...msgs.cancelableUntil} />:{" "}
        <FormattedDate day="2-digit" month="2-digit" year="numeric" value={maxCancellationDate} />
      </span>
    );
  }
  return (
    <span>
      <div
        className={classnames(
          "wbkv9-CancellationMessage",
          "CancellationMessage",
          className,
          styles.textContainer
        )}>
        <div
          className={classnames("wbkv9-CancellationMessage-labelContainer", styles.labelContainer)}>
          <div className={classnames("wbkv9-CancellationMessage-cancelable", styles.cancelable)}>
            <span className={classnames("wbkv9-CancellationMessage-label", styles.label)}>
              {includeIcon && (customIcon || <SecurityIcon />)}
              <FormattedMessage {...msgs.cancelableUntil} />:
            </span>
          </div>
        </div>
        <div
          className={classnames("wbkv9-CancellationMessage-valueContainer", styles.valueContainer)}>
          <div className={classnames("wbkv9-CancellationMessage-cancelable", styles.cancelable)}>
            <span>
              <FormattedDate
                day="2-digit"
                month="2-digit"
                year="numeric"
                value={maxCancellationDate}
              />
            </span>
          </div>
        </div>
      </div>
    </span>
  );
}

CancellationMessage.propTypes = {
  cancellationRelease: PropTypes.number,
  reservationStartDate: PropTypes.string,
  includeIcon: PropTypes.bool,
  className: PropTypes.string,
  mode: PropTypes.string,
  customIcon: PropTypes.any,
};

export default injectIntl(pure(CancellationMessage));
